var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import { clsx } from 'clsx';
import { useRef } from 'react';
function ImageTile(_a) {
    var children = _a.children, image = _a.image, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'surface-white' : _b, _c = _a.imageStyles, imageStyles = _c === void 0 ? '' : _c, imageMargin = _a.imageMargin, _d = _a.outline, outline = _d === void 0 ? false : _d, _e = _a.useHoverOverlay, useHoverOverlay = _e === void 0 ? false : _e, _f = _a.theme, theme = _f === void 0 ? 'light' : _f, _g = _a.className, className = _g === void 0 ? '' : _g;
    var tileRef = useRef(null);
    var src = image.src, alt = image.alt;
    var twMerge = useTWMergeContext().twMerge;
    return (_jsxs("div", __assign({ ref: tileRef, className: twMerge(outline
            ? theme === 'light'
                ? 'border-2 border-border-shoe'
                : 'border-2 border-border-white'
            : '', 'group transition-background duration-200 ease-in-out', "rounded-sm2 overflow-hidden relative bg-".concat(backgroundColor), className) }, { children: [_jsx("div", { title: alt, style: {
                    backgroundImage: "url(".concat(src, ")"),
                }, className: twMerge('group-hover:scale-105', 'transition-transform duration-200 ease-in-out', 'absolute top-0 right-0 w-full h-full bg-no-repeat bg-top bg-cover overflow-hidden', imageMargin ? 'mt-2 mr-3 md:mt-3' : 'm-0', imageStyles) }), _jsx("div", __assign({ className: clsx('z-10 relative w-full h-full transition-background duration-200 ease-in-out', useHoverOverlay && 'md:hover:bg-[rgba(0,0,0,0.2)]') }, { children: children }))] })));
}
export default ImageTile;
